import { connect } from "react-redux";
import { Payment as Component, PaymentProps } from "./Payment.component";
import { RootState } from "../../reducers";
import {
  getBenefitsEnabled,
  getCommonBenefits,
  getDriverList,
  getEpcsInitialize,
  getEpcsStatus,
  getPPUEnabled,
  getSchedulingEnabled,
  getServiceInfo,
  getServiceRequest,
  getServiceRequestPayload,
  getSessionId,
  hasPepSessionSelector,
  getPartnerDetails,
} from "../../selector";
import {
  refreshReducersToInitial,
  requestEpcsInitialize,
  saveRescueDetailsRetrieveResultsRequest,
  setPreviousTransactionAmount,
  updateCCardInfo,
  updateContactNumber,
  updatedEpcsStatus,
  updateDriverList,
  updateEmail,
  updateEpcsStatusIncomplete,
  updateFirstName,
  updateLastName,
  updateOperatorId,
  updatePromoCode,
  updateServiceTransition,
  updateSmsOptIn,
} from "../../action";
import {getOmniStreamlinedFlag} from "../../features";

const mapStateToProps = (state: RootState) =>
  ({
    benefitsEnabled: getBenefitsEnabled(state),
    callId: getSessionId(state),
    commonBenefits: getCommonBenefits(state),
    driverListObj: getDriverList(state),
    epcsInitialize: getEpcsInitialize(state),
    epcsStatus: getEpcsStatus(state),
    hasPepSession: hasPepSessionSelector(state),
    omniStreamlined: getOmniStreamlinedFlag(state),
    partnerDetails: getPartnerDetails(state),
    ppuEnabled: getPPUEnabled(state),
    schedulingEnabledInConfiguration: getSchedulingEnabled(state),
    serviceInfo: getServiceInfo(state),
    serviceRequest: getServiceRequest(state),
    serviceRequestPayload: getServiceRequestPayload(state),
  } as Pick<
    PaymentProps,
    | "benefitsEnabled"
    | "callId"
    | "commonBenefits"
    | "driverListObj"
    | "epcsInitialize"
    | "epcsStatus"
    | "hasPepSession"
    | "omniStreamlined"
    | "partnerDetails"
    | "ppuEnabled"
    | "schedulingEnabledInConfiguration"
    | "serviceInfo"
    | "serviceRequest"
    | "serviceRequestPayload"
  >);

const mapDispatchToProps = {
  refreshReducersToInitial,
  requestEpcsInitialize,
  saveRescueDetailsRetrieveResultsRequest,
  setPreviousTransactionAmount,
  updateContactNumber,
  updateCCardInfo,
  updateDriverList,
  updateEmail,
  updateEpcsStatusIncomplete,
  updateFirstName,
  updateLastName,
  updateOperatorId,
  updatePromoCode,
  updateServiceTransition,
  updateSmsOptIn,
  updatedEpcsStatus,
} as Pick<
  PaymentProps,
  | "refreshReducersToInitial"
  | "requestEpcsInitialize"
  | "saveRescueDetailsRetrieveResultsRequest"
  | "setPreviousTransactionAmount"
  | "updateCCardInfo"
  | "updateContactNumber"
  | "updateDriverList"
  | "updateEmail"
  | "updateEpcsStatusIncomplete"
  | "updateFirstName"
  | "updateLastName"
  | "updateOperatorId"
  | "updatePromoCode"
  | "updateServiceTransition"
  | "updateSmsOptIn"
  | "updatedEpcsStatus"
>;

export const Payment = connect(mapStateToProps, mapDispatchToProps)(Component);
